export const en = {
	'К сожалению, по вашему запросу ничего не нашлось. Подпишитесь на результаты поиска — мы сообщим вам, как только появится подходящее предложение.':
		'Unfortunately, nothing was found for your request. Subscribe to the search results - we will notify you as soon as a suitable offer appears.',

	'К сожалению, мы не нашли склады, отвечающие критериям вашего запроса. Подобрали несколько предложений, которые отвечают указанным параметрам, но расположены дальше.':
		'Unfortunately, we did not find warehouses that meet the criteria of your request. We have selected several offers that meet the specified parameters, but are located further.',
};
